import { useState, useEffect, useMemo, useCallback } from 'react'
import {
  getKyousouApiClient,
  ApiErrorResponse,
  handleError,
} from '../../../services/network'
import { useSnackBar } from '../../../providers/snack_bar_provider'

interface CheckResult {
  isLoading: boolean
  enableGenerate: boolean
  isPaidPlan: boolean
  remainCount: number | null
}

export const useCheckGenerateLimit = (): CheckResult => {
  const apiClient = useMemo(() => getKyousouApiClient(), [])
  const { showSnackBar } = useSnackBar()
  const [result, setResult] = useState<CheckResult>({
    isLoading: true,
    enableGenerate: false,
    isPaidPlan: false,
    remainCount: null,
  })

  const checkGenerateLimit = useCallback(async () => {
    setResult((prev) => ({ ...prev, isLoading: true }))

    await apiClient.business
      .checkGenerateLimitList()
      .then((res) => {
        setResult({
          isLoading: false,
          enableGenerate: res.data.enableGenerate,
          isPaidPlan: res.data.isPaidPlan,
          remainCount: res.data.remainCount,
        })
      })
      .catch((e: ApiErrorResponse) => {
        handleError(e, showSnackBar)
      })
  }, [apiClient, showSnackBar])

  useEffect(() => {
    checkGenerateLimit()
  }, [checkGenerateLimit])

  return {
    isLoading: result.isLoading,
    enableGenerate: result.enableGenerate,
    isPaidPlan: result.isPaidPlan,
    remainCount: result.remainCount,
  }
}
